































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ICourse, IProgram } from '../Scripts/ISearchService';
import { msiInfo } from '../Scripts/MsiInfo';

@Component({
	components: {
	},
	directives: {
	}
})
export default class ResultDetailCourse extends Vue {
	@Prop() public item!: ICourse | IProgram;
	@Prop() public interactive!: boolean;

	public requestMoreInfo (item: ICourse | IProgram): void {
		this.$emit('request-more-info', item);
	}

	get msiClassifications (): string {
		if (!this.item.msiCodes) return 'N/A';

		return this.item.msiCodes.map(c => msiInfo.getMetadata(c).title).join(', ');
	}
}
